import type { EditorThemeClasses } from "lexical";

export const lexicalTheme: EditorThemeClasses = {
	paragraph: "lexical-paragraph",
	heading: {
		h1: "lexical-h1",
		h2: "lexical-h2",
		h3: "lexical-h3",
		h4: "lexical-h4",
		h5: "lexical-h5",
		h6: "lexical-h6",
	},
	list: {
		ul: "lexical-ul",
		ol: "lexical-ol",
		listitem: "lexical-listitem",
		nested: {
			listitem: "lexical-nested-listitem",
		},
	},
	link: "lexical-link",
	quote: "lexical-quote",
	code: "lexical-code",
	codeHighlight: {},
	text: {
		bold: "lexical-bold",
		italic: "lexical-italic",
		strikethrough: "lexical-strikethrough",
		underline: "lexical-underline",
		code: "lexical-inline-code",
	},
};
